<a class="skip_lnk" [href]="skipToContentPath" (click)="skipToContent($event)">Skip to content</a>
<div class="app-container" *ngIf="isReady$ | async">
  <app-header></app-header>
  <main>
    <div class="router-container" id="main-content" #mainContent>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
